// import { TaskType } from "../../../../../../constants/dataEnum";
import {IFCSectionName} from 'constants/dataEnum';
import {getQuadrant} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';

// // checker
// const checkTasksContent = () => {
//   let isShowPickTipEditButton = false;
//   let isUnfinishedTaskExists = false;

//   const checkUnfinishedTask = (task) => {
//     if (task.type === TaskType.DELAY && !task.delayTime) {
//       isUnfinishedTaskExists = true;
//     }

//     if (
//       (task.type === TaskType.USER_CONFIRMATION || task.type === TaskType.USER_CONFIRMATION_EJECT)
//       && task?.message === ''
//     ) {
//       isUnfinishedTaskExists = true;
//     }
//   }

//   const checkShowEditButton = (task) => {
//     if (task !== TaskType.PICK_TIP) {
//       isShowPickTipEditButton = true;
//     }
//   };

//   for (let i = 0; i < tasks.length; i += 1) {
//     let task = tasks[i];

//     checkUnfinishedTask(task);
//     checkShowEditButton(task);

//   }
// };

export function getAspirateDispenseWellGroupName(
  row,
  column,
  rowTipCount,
  columnTipCount,
  labwareRowCount,
  labwareColumnCount,
  labwareIndex,
) {
  if (labwareIndex) {
    const key = `${labwareRowCount}.${labwareColumnCount}`;
    const IFCTypeSectionName = IFCSectionName[key];
    return IFCTypeSectionName ? IFCTypeSectionName[labwareIndex] : '';
  }
  if (rowTipCount >= labwareRowCount && columnTipCount >= labwareColumnCount) {
    return 'All Well';
  }

  // else not all well
  switch (rowTipCount) {
    case 1:
      if (labwareRowCount === 1) {
        return `Col ${column}`;
      }
      if (columnTipCount === 1 && labwareColumnCount !== 1) return `${row}${column}`;
      if (labwareRowCount / 8 > 1) {
        return `Row ${row}-${column % 2 !== 0 ? 'A' : 'B'}`;
      }
      return `Row ${row}`;
    case 8: {
      if (columnTipCount === 12) return `Quadrant ${getQuadrant(row.charCodeAt(0) - 64, column)}`;
      if (labwareColumnCount / 12 > 1) {
        return `Col ${column}-${(row.charCodeAt(0) - 64) % 2 !== 0 ? 1 : 2}`;
      }

      return `Col ${column}`;
    }
    default:
      if (labwareColumnCount / 12 > 1) {
        return `Quadrant ${getQuadrant(row.charCodeAt(0) - 64, column)} ${row}${column}:${String.fromCharCode(row.charCodeAt(0) + 2 * (rowTipCount - 1))}${column + 2 * (columnTipCount - 1)}`;
      }

      // labware 8 well
      if (labwareRowCount === 8 && labwareColumnCount === 1) {
        return `Row ${row}:Row ${String.fromCharCode(row.charCodeAt(0) + rowTipCount - 1)}`;
      }

      // labware 12 well
      if (labwareRowCount === 1 && labwareColumnCount === 12) {
        return `Col ${column}:Col ${column + columnTipCount - 1}`;
      }

      return `${row}${column}:${String.fromCharCode(row.charCodeAt(0) + rowTipCount - 1)}${column + columnTipCount - 1}`;
  }
}

export const generateTipCountLabel = (rowTipCount, columnTipCount) => {
  if (
    (rowTipCount === 1 && columnTipCount === 1) ||
    (rowTipCount === 8 && columnTipCount === 1) ||
    (rowTipCount === 1 && columnTipCount === 12) ||
    (rowTipCount === 8 && columnTipCount === 12)
  ) {
    return `[${rowTipCount * columnTipCount}]`;
  }

  return `[${rowTipCount}x${columnTipCount}]`;
};
